// extracted by mini-css-extract-plugin
export var genbtncounter = "product-table-item-module--genbtncounter--5Qwoc";